import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type PromptStarterSlots = {
  root: NonNullable<Slot<'div'>>;
  primaryAction: NonNullable<Slot<'button'>>;
  icon?: Slot<'span'>;
  category?: Slot<'span'>;
  prompt: NonNullable<Slot<'span'>>;
  reasonMarker?: Slot<'span'>;
  actions?: Slot<'span'>;
};

/**
 * PromptStarter Props
 */
export type PromptStarterProps = Omit<ComponentProps<PromptStarterSlots>, 'disabled'>;

/**
 * State used in rendering PromptStarter
 */
export type PromptStarterState = ComponentState<PromptStarterSlots> & {
  isSingleColumn?: boolean;
};
